import { useQuery } from "react-query";
import axiosClient from "../../../../../../../../../lib/axios";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { IConsultarEmissaoPix } from "../../../../../../../../../types/mutations/financeiro/emitir-pix";
import { useFormContext } from "react-hook-form";
import moment from "moment";

export default function AguardandoPagamento({
    codigo
}: AguardandoPagamentoProps) {

    const [dataConsulta, setDataConsulta] = useState<IConsultarEmissaoPix>()
    const [stop, setStop] = useState<boolean>(false);
    const { setValue } = useFormContext();

    useQuery({
        queryKey: ["consultar-emissao-pix"],
        queryFn: () => axiosClient.get(`/financeiro/contas-receber/consultar-emissao-pix/${codigo}`),
        cacheTime: 0,
        refetchInterval: stop ? false : 3000,
        enabled: !dataConsulta || dataConsulta.status === 'Aguardando pagamento',
        onSuccess({ data }) {
            setDataConsulta(data);
            if (data.status == 'Pago'){
                setStop(true);

                setValue('recebimentoRegistrado', {
                    recebido_por: data.usuario,
                    data_hora: moment.now(),
                    recibos: [{
                        recibo: data.recibo,
                        forma_recebimento: "Pix Instantâneo",
                        valor: data.valor
                    }]
                })

                return;
            }
        },
    });

    return (
        <Box display={'flex'} >
            {
                dataConsulta &&
                <>
                    <Box alignSelf={'flex-start'} mt={0.5} mr={1} width={14} height={14} borderRadius={'50%'} bgcolor={'#FFD12E'} />
                    <Box display="flex" flexDirection="column" justifyContent="center">
                        <Typography mb={-0.5} fontWeight={'bold'}>{dataConsulta.status}</Typography>
                        <Typography variant="caption">Favor realizar o pagamento em até 5 minuto(s)</Typography>
                    </Box>
                </>
            }
        </Box>
    )
}

interface AguardandoPagamentoProps {
    codigo: string;
}
